import React, { useContext, useState } from "react";
import { useLanguage } from "./LanguageContext";
import { SvgIcon } from "@mui/material";
import {
  AppBar,
  Toolbar,
  Box,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import TranslatedText from "./TranslatedText";
import AuthContext from "./AuthContext";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

const DrawerAppBar = ({ handleOpen, ...props }) => {
  const drawerWidth = 240;
  const navItems = ["Діяльність", "Про нас", "Контакти", "Вхід"];
  const navItemsResponsive = [
    "Головна",
    "Діяльність",
    "Про нас",
    "Контакти",
    "Вхід",
  ];
  const { isLoggedIn, setIsLoggedIn } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const getLinkPathAndColor = (item) => {
    switch (item) {
      case "Головна":
        return { path: "/", color: "#555656" };
      case "Діяльність":
        return { path: "/activities", color: "#555656" };
      case "Про нас":
        return { path: "/about-us", color: "#555656" };
      case "Контакти":
        return { path: "/contact", color: "#555656" };
      case "Вхід":
        return { path: "/login-page", color: "#4017176" };
      default:
        return { path: "/", color: "#4017176" };
    }
  };

  // meny
  const renderNavItems = () => {
    return (
      <>
        <Button>
          <Link to="/">
            <SvgIcon
              component={HomeRoundedIcon}
              fontSize="large"
              sx={{ color: "#2875b0", width: "3vw", height: "4vh" }}
            />
          </Link>
        </Button>
        {navItems.map((item, index) => {
          const { path, color } = getLinkPathAndColor(item);

          let icon = null;
          let buttonText = item;

          if (item === "Вхід") {
            if (isLoggedIn) {
              icon = <SvgIcon component={LogoutRoundedIcon} />;
              buttonText = "вийти";
            } else {
              icon = <SvgIcon component={LoginRoundedIcon} />;
            }
          }

          return (
            <Button
              className="login-btn"
              key={index}
              component={Link}
              to={path}
              sx={{ color: color, textDecoration: "none" }}
              onClick={
                item === "Вхід"
                  ? isLoggedIn
                    ? handleLogout
                    : handleClickOpen
                  : null
              }
            >
              {icon}
              {item !== "Вхід" && <TranslatedText defaultText={buttonText} />}
            </Button>
          );
        })}
      </>
    );
  };

  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const { language, setLanguage } = useLanguage();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
    handleMenuClose();
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleClickOpen = () => {
    handleOpen();
  };

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("password");
    setIsLoggedIn(false);
  };

  // hamburger meny
  const renderDrawerItems = () => {
    return navItemsResponsive.map((item) => {
      const { path, color } = getLinkPathAndColor(item);
      const buttonText =
        item === "Вхід" ? (isLoggedIn ? "вийти" : "Вхід") : item;
      return (
        <ListItem key={item} disablePadding>
          <ListItemButton
            component={Link}
            to={path}
            sx={{ color: color, textDecoration: "none", textAlign: "center" }}
            onClick={
              item === "Вхід"
                ? isLoggedIn
                  ? handleLogout
                  : handleClickOpen
                : null
            }
          >
            <ListItemText
              primary={<TranslatedText defaultText={buttonText} />}
            />
          </ListItemButton>
        </ListItem>
      );
    });
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        <img
          src={logo}
          alt="Search"
          style={{ width: "200px", height: "48px" }}
        />
      </Typography>
      <Divider />
      <List>{renderDrawerItems()}</List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          background: "white",
        }}
      >
        <Toolbar>
          <IconButton
            background="white"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              background: "white",
              fontSize: "5px",
              display: { xs: "none", sm: "block" },
            }}
          >
            <img
              src={logo}
              alt="Search"
              style={{ width: "200px", height: "52px" }}
            />
          </Typography>
          <Box
            sx={{ background: "white", display: { xs: "none", sm: "block" } }}
          >
            {renderNavItems()}
          </Box>
          <IconButton
            edge="end"
            color="inherit"
            aria-label="language"
            onClick={handleMenuOpen}
          >
            <LanguageIcon sx={{ fill: "#555656", background: "white" }} />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleLanguageChange("en")}>
              English
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange("no")}>
              Norsk
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange("uk")}>
              Українська
            </MenuItem>
            <MenuItem onClick={() => handleLanguageChange("pl")}>
              Polski
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },

            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
};

export default DrawerAppBar;
